import React from 'react';

// Sidebar "Welcome" block + organiser contact card, shared by the visitor and
// delegate sidebars. Styled by the .dd-* rules in public/css/responsive-fixes.css;
// the surrounding .main-sidemenu should carry the "dd-modern" class.
const read = (key) => {
    try {
        return JSON.parse(sessionStorage.getItem(key));
    } catch (e) {
        return null;
    }
};

const DrawerContactCard = ({ name }) => {
    const drawer = (read('sessionVisitorDrawerData') || [])[0] || {};
    const addr = read('FormatedAddress') || [];
    const mobs = (read('FormatedMobNo') || []).filter(Boolean);

    // Address comes as pairs per line: [0,1] [2,3] [4,5] [6]
    const addrLines = [[0, 1], [2, 3], [4, 5], [6]]
        .map(idx => idx.map(i => addr[i]).filter(Boolean).join(', '))
        .filter(Boolean);

    // The saved phone text starts with "Phone:"; the card already shows that label
    const landline = drawer.Phone ? String(drawer.Phone).replace(/^\s*phone\s*:\s*/i, '') : '';
    const phones = [landline, ...mobs].filter(Boolean);

    return (
        <div className="dd-sidebar">
            <div className="dd-welcome">Welcome –</div>
            <h4 className="dd-name">{name}</h4>
            <span className="dd-rule"></span>
            {drawer.Header && <p className="dd-intro">{drawer.Header}</p>}

            <div className="dd-card">
                <div className="dd-item">
                    <span className="dd-icon"><i className="fa fa-building"></i></span>
                    <div>
                        {drawer.Header2 && <div className="dd-org">{drawer.Header2}</div>}
                        <div className="dd-text">
                            {addrLines.map((line, i) => <div key={i}>{line}</div>)}
                        </div>
                    </div>
                </div>

                {phones.length > 0 && <>
                    <div className="dd-sep"></div>
                    <div className="dd-item dd-item-box">
                        <span className="dd-icon"><i className="fa fa-phone"></i></span>
                        <div>
                            <div className="dd-label">Phone</div>
                            {phones.map((p, i) => <div key={i} className="dd-value">{p}</div>)}
                        </div>
                    </div>
                </>}

                {drawer.Email && (
                    <div className="dd-item dd-item-box">
                        <span className="dd-icon"><i className="fa fa-envelope-o"></i></span>
                        <div style={{ minWidth: 0 }}>
                            <div className="dd-label">Email</div>
                            <a className="dd-value dd-email" href={`mailto:${drawer.Email}`}>{drawer.Email}</a>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DrawerContactCard;
